module.exports = __webpack_public_path__ + "img/wzf_15.0860f068.png";